(function () {
  const builder = document.querySelector("[data-rush-builder]");
  if (!builder) return;
  if (builder.dataset.builderInitialized === "true") return;
  builder.dataset.builderInitialized = "true";

  const stageOrder = ["body", "back-shell", "face", "thumbsticks", "pro-features", "add-ons"];
  const basePrice = Number(builder.dataset.basePrice || 0);
  const currency = builder.dataset.currency || "USD";
  const controllerVariantId = Number(builder.dataset.controllerVariantId || 0);
  const sendInVariantId = Number(builder.dataset.sendInVariantId || 0);
  const sendInPrice = Number(builder.dataset.sendInPrice || 0);
  const cartAddUrl = builder.dataset.cartAddUrl || "/cart/add.js";
  const cartChangeUrl = builder.dataset.cartChangeUrl || "/cart/change.js";
  const cartUrl = builder.dataset.cartUrl || "/cart";
  const upgradeVariants = (() => {
    try {
      return JSON.parse(builder.querySelector("[data-upgrade-variants]")?.textContent || "[]")
        .filter((variant) => Number(variant.price) > 0)
        .map((variant) => ({ id: Number(variant.id), price: Number(variant.price) }));
    } catch (error) {
      return [];
    }
  })();
  const selections = new Map();
  let activeStage = "body";
  let engravingPrice = 0;
  let shellMaterials = [];
  let modelMaterials = [];
  let selectedShellColor = "#151a1d";
  let artworkUrl = "";
  let currentTotal = basePrice;
  let currentUpgradeTotal = 0;

  const stageButtons = [...builder.querySelectorAll("[data-stage-target]")];
  const stagePanels = [...builder.querySelectorAll("[data-stage-panel]")];
  const totals = [...builder.querySelectorAll("[data-builder-total]")];
  const controllerModel = builder.querySelector("[data-controller-model]");
  const selectionNote = builder.querySelector("[data-selection-note]");
  const summaryName = builder.querySelector("[data-summary-name]");
  const nextButton = builder.querySelector("[data-builder-next]");
  const properties = builder.querySelector("[data-builder-properties]");
  const toast = builder.querySelector("[data-builder-toast]");
  const previewStatus = builder.querySelector("[data-preview-status]");
  const resetViewButton = builder.querySelector("[data-reset-view]");
  const modelLoader = builder.querySelector("[data-model-loader]");
  const modelLoaderLabel = builder.querySelector("[data-model-loader-label]");
  const modelProgress = builder.querySelector("[data-model-progress]");
  const artworkInput = builder.querySelector("[data-artwork-input]");
  const artworkProof = builder.querySelector("[data-artwork-proof]");
  const artworkPreview = builder.querySelector("[data-artwork-preview]");
  const artworkName = builder.querySelector("[data-artwork-name]");
  const dispatchLabel = builder.querySelector("[data-builder-dispatch]");
  const buildCodeLabel = builder.querySelector("[data-builder-code]");
  const checkoutStatus = builder.querySelector("[data-checkout-status]");
  const cartButton = builder.querySelector("[data-builder-cart]");
  const builderForm = builder.querySelector("[data-builder-form]");
  const sendInConfirm = builder.querySelector("[data-send-in-confirm]");
  const sendInEligibility = builder.querySelector("[data-send-in-eligibility]");

  if (builder.dataset.launchLocked === "true") {
    const lockedSurface = builder.querySelector(".rush-builder__workspace");
    const lockedStages = builder.querySelector(".rush-builder__stages");
    lockedSurface?.setAttribute("inert", "");
    lockedStages?.setAttribute("inert", "");
    builder.querySelector("[data-builder-lock] input")?.focus({ preventScroll: true });
  }

  const presetOptions = {
    fps: {
      "Back Shell": "Performance Grip",
      Thumbsticks: "Tall Precision",
      "Stick Sensors": "Hall Effect",
      "Back Buttons": "Rush Rear Duo",
      Triggers: "Rapid Click Triggers",
      Bumpers: "Tactile Bumpers"
    },
    "anti-drift": {
      "Stick Sensors": "Hall Effect"
    },
    creator: {
      Shell: "Crimson Rush",
      "Middle Trim": "Brushed Silver",
      "Touchpad": "Carbon Weave",
      "Face Buttons": "Crimson Symbols",
      "Thumbstick Color": "Rush Red"
    }
  };

  const stageViews = {
    body: { orbit: "180deg 72deg 138%", mobileOrbit: "180deg 72deg 108%", label: "Front shell view" },
    "back-shell": { orbit: "0deg 72deg 132%", mobileOrbit: "0deg 72deg 104%", label: "Rear shell view" },
    face: { orbit: "180deg 68deg 112%", mobileOrbit: "180deg 68deg 94%", label: "Face controls view" },
    thumbsticks: { orbit: "180deg 78deg 108%", mobileOrbit: "180deg 78deg 92%", label: "Thumbstick detail view" },
    "pro-features": { orbit: "12deg 72deg 126%", mobileOrbit: "12deg 72deg 102%", label: "Rear feature view" },
    "add-ons": { orbit: "180deg 72deg 138%", mobileOrbit: "180deg 72deg 108%", label: "Complete build view" }
  };

  function setPreviewStatus(message, mode = "ready") {
    if (!previewStatus) return;
    previewStatus.textContent = message;
    previewStatus.dataset.mode = mode;
  }

  function focusStageView(name, announce = false) {
    if (!controllerModel) return;
    const view = stageViews[name] || stageViews.body;
    controllerModel.cameraOrbit = window.matchMedia("(max-width: 749px)").matches ? view.mobileOrbit : view.orbit;
    if (announce) setPreviewStatus(view.label);
  }

  function applyShellColor(hex) {
    selectedShellColor = hex;
    shellMaterials.forEach((material) => {
      material.pbrMetallicRoughness.setBaseColorFactor(hex);
      material.pbrMetallicRoughness.setMetallicFactor(.12);
      material.pbrMetallicRoughness.setRoughnessFactor(.5);
    });
    const touchpadSelection = builder.querySelector('[data-option-group="Touchpad"].is-selected');
    if (touchpadSelection?.dataset.option === "Match Shell") applyMaterialColor("RUSH_TOUCHPAD", hex);
  }

  function applyMaterialColor(materialName, hex) {
    const materials = modelMaterials.filter((item) => item.name === materialName || item.name.startsWith(`${materialName}__`));
    materials.forEach((material) => {
      material.pbrMetallicRoughness.setBaseColorFactor(hex);
      material.pbrMetallicRoughness.setMetallicFactor(.1);
      material.pbrMetallicRoughness.setRoughnessFactor(.5);
    });
  }

  function connectControllerViewer() {
    if (!controllerModel) return;

    const handleLoad = () => {
      controllerModel.classList.add("is-ready");
      const materials = controllerModel.model?.materials || [];
      modelMaterials = materials;
      shellMaterials = materials.filter((material) => material.name === "RUSH_SHELL" || material.name.startsWith("RUSH_SHELL__"));
      if (!shellMaterials.length) shellMaterials = materials.slice(0, 1);
      applyShellColor(selectedShellColor);
      builder.querySelectorAll("[data-model-material].is-selected").forEach((button) => {
        applyMaterialColor(button.dataset.modelMaterial, button.dataset.color);
      });
      if (modelProgress) modelProgress.style.width = "100%";
      setPreviewStatus("Live 3D ready");
      focusStageView(activeStage);
    };

    controllerModel.addEventListener("load", handleLoad);
    controllerModel.addEventListener("progress", (event) => {
      const progress = Math.max(0, Math.min(1, Number(event.detail?.totalProgress || 0)));
      if (modelProgress) modelProgress.style.width = `${Math.round(progress * 100)}%`;
      if (modelLoaderLabel && progress > 0) modelLoaderLabel.textContent = `Loading 3D preview ${Math.round(progress * 100)}%`;
    });
    controllerModel.addEventListener("error", () => {
      controllerModel.classList.add("has-error");
      if (modelLoaderLabel) modelLoaderLabel.textContent = "3D preview unavailable";
      if (modelLoader) modelLoader.classList.add("has-error");
      setPreviewStatus("Preview unavailable — your selections are still saved", "error");
    });

    if (controllerModel.loaded) handleLoad();
  }

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  function getServicePricing() {
    const isSendIn = selections.get("Build Service")?.name === "Send-In Service";
    return {
      isSendIn,
      variantId: isSendIn ? sendInVariantId : controllerVariantId,
      base: isSendIn ? (sendInPrice || Math.max(0, basePrice - 4000)) : basePrice
    };
  }

  function resolveUpgradeLines(amount) {
    if (amount === 0) return [];
    const denominations = [...upgradeVariants].sort((a, b) => b.price - a.price);
    const counts = new Int32Array(amount + 1);
    const choices = new Int32Array(amount + 1);
    counts.fill(2147483647);
    choices.fill(-1);
    counts[0] = 0;
    for (let subtotal = 1; subtotal <= amount; subtotal += 1) {
      denominations.forEach((variant, index) => {
        const previous = subtotal - variant.price;
        if (previous < 0 || counts[previous] === 2147483647) return;
        if (counts[previous] + 1 < counts[subtotal]) {
          counts[subtotal] = counts[previous] + 1;
          choices[subtotal] = index;
        }
      });
    }
    if (choices[amount] === -1) return null;
    const quantities = new Map();
    let remainder = amount;
    while (remainder > 0) {
      const variant = denominations[choices[remainder]];
      quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1);
      remainder -= variant.price;
    }
    return [...quantities.entries()].map(([id, quantity]) => ({ id, quantity }));
  }

  function getCheckoutIssue() {
    const service = getServicePricing();
    if (!controllerVariantId) return "Assign the Controller product in the Custom Lab section settings.";
    if (service.isSendIn && !sendInVariantId) return "Assign the Send-in service product before offering this option.";
    if (service.isSendIn && !sendInEligibility?.checked) return "Confirm send-in eligibility before adding this build to cart.";
    if (currentUpgradeTotal > 0 && !upgradeVariants.length) return "Assign the hidden Custom Lab upgrade product before selling paid upgrades.";
    if (resolveUpgradeLines(currentUpgradeTotal) === null) return `The upgrade product cannot represent ${money(currentUpgradeTotal)}. Add a $1 pricing variant.`;
    return "";
  }

  function syncCheckoutState() {
    const issue = getCheckoutIssue();
    if (sendInConfirm) sendInConfirm.hidden = !getServicePricing().isSendIn;
    if (checkoutStatus) {
      checkoutStatus.textContent = issue || "Secure Shopify checkout · configuration and build code included with the order";
      checkoutStatus.classList.toggle("has-error", Boolean(issue));
    }
    if (cartButton) {
      cartButton.disabled = Boolean(issue);
      cartButton.textContent = issue ? "Setup required" : "Add build to cart";
    }
  }

  function syncSummary() {
    const optionTotal = [...selections.entries()].reduce((sum, [group, item]) => group === "Build Service" ? sum : sum + Number(item.price || 0), 0);
    const servicePricing = getServicePricing();
    currentUpgradeTotal = optionTotal + engravingPrice;
    currentTotal = servicePricing.base + currentUpgradeTotal;
    totals.forEach((node) => { node.textContent = money(currentTotal); });

    const shell = selections.get("Shell")?.name || "Carbon Black";
    const featureCount = [...selections.keys()].filter((key) => ["Back Buttons", "Triggers", "Bumpers", "Carrying Case", "Cable", "Warranty"].includes(key)).length;
    const summary = `${shell} / ${featureCount ? `${featureCount} upgrade${featureCount > 1 ? "s" : ""}` : "Standard"}`;
    if (selectionNote) selectionNote.textContent = summary;
    if (summaryName) summaryName.textContent = summary;
    const service = selections.get("Build Service")?.name;
    if (dispatchLabel) dispatchLabel.textContent = service === "Send-In Service" ? "8–12 days after arrival" : builder.dataset.buildTime;

    if (properties) {
      properties.innerHTML = "";
      selections.forEach((item, group) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${group}]`;
        input.value = item.name;
        properties.appendChild(input);
      });
      const engraving = builder.querySelector("[data-engraving]")?.value.trim();
      if (engraving) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[Engraving]";
        input.value = engraving;
        properties.appendChild(input);
      }
      const buildCode = createBuildCode();
      [
        ["Rush build code", buildCode],
        ["Configured total", money(currentTotal)],
        ["Paid upgrades", money(currentUpgradeTotal)],
        ["Estimated dispatch", dispatchLabel?.textContent || builder.dataset.buildTime],
        ["Artwork proof", artworkInput?.files?.[0]?.name || "None"]
      ].forEach(([name, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${name}]`;
        input.value = value;
        properties.appendChild(input);
      });
    }
    syncCheckoutState();
  }

  function createBuildCode() {
    const source = [...selections.values()].map((item) => item.name).join("|") + (engraving?.value || "");
    let hash = 2166136261;
    for (let index = 0; index < source.length; index += 1) {
      hash ^= source.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return `RUSH-${(hash >>> 0).toString(36).toUpperCase().padStart(7, "0")}`;
  }

  function serializeBuild() {
    return {
      selections: Object.fromEntries([...selections.entries()].map(([group, item]) => [group, item.name])),
      engraving: engraving?.value || "",
      artwork: artworkInput?.files?.[0]?.name || ""
    };
  }

  function selectOption(group, option) {
    const candidates = [...builder.querySelectorAll("[data-option-group]")];
    const target = candidates.find((button) => button.dataset.optionGroup === group && button.dataset.option === option);
    if (!target) return;
    if (target.classList.contains("rush-builder__feature") && target.getAttribute("aria-pressed") === "true") return;
    target.click();
  }

  function clearOptionalFeatures() {
    builder.querySelectorAll(".rush-builder__feature.is-selected").forEach((button) => button.click());
  }

  function applyBuild(data, announce = true) {
    if (!data?.selections) return;
    clearOptionalFeatures();
    Object.entries(data.selections).forEach(([group, option]) => selectOption(group, option));
    if (engraving && typeof data.engraving === "string") {
      engraving.value = data.engraving;
      engravingPrice = engraving.value.trim() ? 800 : 0;
    }
    syncSummary();
    if (announce) showToast("Saved Rush build restored.");
  }

  function showToast(message, duration = 2800) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.setTimeout(() => toast.classList.remove("is-visible"), duration);
  }

  function selectStage(name) {
    activeStage = name;
    stageButtons.forEach((button) => {
      const selected = button.dataset.stageTarget === name;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-selected", String(selected));
      if (selected) button.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    });
    stagePanels.forEach((panel) => {
      const selected = panel.dataset.stagePanel === name;
      panel.classList.toggle("is-active", selected);
      panel.hidden = !selected;
    });
    const panelScroller = builder.querySelector(".rush-builder__panels");
    if (panelScroller) panelScroller.scrollTop = 0;
    focusStageView(name, controllerModel?.loaded);
    nextButton.innerHTML = name === "add-ons"
      ? 'Review <span class="material-symbols-outlined" aria-hidden="true">check</span>'
      : 'Next <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>';
  }

  stageButtons.forEach((button) => button.addEventListener("click", () => selectStage(button.dataset.stageTarget)));

  builder.querySelectorAll("[data-subtab]").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = button.closest("[data-stage-panel]");
      panel.querySelectorAll("[data-subtab]").forEach((tab) => {
        const selected = tab === button;
        tab.classList.toggle("is-active", selected);
        tab.setAttribute("aria-selected", String(selected));
      });
      panel.querySelectorAll("[data-subpanel]").forEach((subpanel) => {
        const selected = subpanel.dataset.subpanel === button.dataset.subtab;
        subpanel.classList.toggle("is-active", selected);
        subpanel.hidden = !selected;
      });
    });
  });

  builder.querySelectorAll("[data-option-group]").forEach((button) => {
    button.addEventListener("click", () => {
      const group = button.dataset.optionGroup;
      const isFeature = button.classList.contains("rush-builder__feature");
      const isActive = button.getAttribute("aria-pressed") === "true";

      if (isFeature && isActive) {
        button.classList.remove("is-selected");
        button.setAttribute("aria-pressed", "false");
        selections.delete(group);
      } else {
        if (!isFeature) {
          builder.querySelectorAll(`[data-option-group="${CSS.escape(group)}"]`).forEach((item) => {
            item.classList.remove("is-selected");
            item.setAttribute("aria-pressed", "false");
          });
        }
        button.classList.add("is-selected");
        button.setAttribute("aria-pressed", "true");
        selections.set(group, { name: button.dataset.option, price: Number(button.dataset.price || 0) });
      }

      if (button.dataset.color && button.dataset.modelMaterial) {
        applyMaterialColor(button.dataset.modelMaterial, button.dataset.color);
        setPreviewStatus(`${button.dataset.option} shown in live preview`);
      } else if (button.dataset.color) {
        applyShellColor(button.dataset.color);
        setPreviewStatus(`${button.dataset.option} shown in live preview`);
      } else {
        setPreviewStatus(`${button.dataset.option} saved — this hardware detail is not shown on the model`, "saved");
      }
      const swatch = button.style.getPropertyValue("--swatch");
      if (swatch) builder.style.setProperty("--builder-glow", swatch);
      syncSummary();
    });
  });

  const engraving = builder.querySelector("[data-engraving]");
  engraving?.addEventListener("input", () => {
    engravingPrice = engraving.value.trim() ? 800 : 0;
    setPreviewStatus(engraving.value.trim() ? "Engraving saved — placement is confirmed after order" : "Engraving removed", "saved");
    syncSummary();
  });

  artworkInput?.addEventListener("change", () => {
    const file = artworkInput.files?.[0];
    if (!file) return;
    if (![/image\/png/, /image\/jpeg/].some((type) => type.test(file.type)) || file.size > 10 * 1024 * 1024) {
      artworkInput.value = "";
      showToast("Choose a PNG or JPG smaller than 10MB.", 3600);
      return;
    }
    if (artworkUrl) URL.revokeObjectURL(artworkUrl);
    artworkUrl = URL.createObjectURL(file);
    artworkPreview.src = artworkUrl;
    artworkName.textContent = file.name;
    artworkProof.hidden = false;
    builder.classList.add("has-artwork");
    setPreviewStatus("Artwork proof loaded — final placement is reviewed after order", "saved");
    syncSummary();
  });

  sendInEligibility?.addEventListener("change", syncCheckoutState);

  builder.querySelector("[data-artwork-remove]")?.addEventListener("click", () => {
    if (artworkUrl) URL.revokeObjectURL(artworkUrl);
    artworkUrl = "";
    artworkInput.value = "";
    artworkPreview.removeAttribute("src");
    artworkProof.hidden = true;
    builder.classList.remove("has-artwork");
    setPreviewStatus("Custom artwork removed", "saved");
    syncSummary();
  });

  builder.querySelectorAll("[data-build-preset]").forEach((button) => {
    button.addEventListener("click", () => {
      const preset = button.dataset.buildPreset;
      clearOptionalFeatures();
      if (preset === "reset") {
        builder.querySelectorAll("[data-option-group]:not(.rush-builder__feature)").forEach((option) => {
          const group = option.dataset.optionGroup;
          const first = builder.querySelector(`[data-option-group="${CSS.escape(group)}"]`);
          if (option === first && option.getAttribute("aria-pressed") !== "true") option.click();
        });
      } else {
        Object.entries(presetOptions[preset] || {}).forEach(([group, option]) => selectOption(group, option));
      }
      builder.querySelectorAll("[data-build-preset]").forEach((item) => item.classList.toggle("is-active", item === button));
      syncSummary();
      showToast(`${button.textContent.trim()} loadout applied.`);
    });
  });

  builder.querySelector("[data-builder-save]")?.addEventListener("click", () => {
    const data = serializeBuild();
    const code = createBuildCode();
    try {
      localStorage.setItem("rush-controller-build", JSON.stringify(data));
    } catch (error) {
      showToast("This browser could not store the build.");
      return;
    }
    if (buildCodeLabel) buildCodeLabel.textContent = code;
    showToast(`Build saved as ${code}.`);
  });

  builder.querySelector("[data-builder-share]")?.addEventListener("click", async () => {
    const data = serializeBuild();
    const url = new URL(window.location.href);
    url.hash = `rush-build=${encodeURIComponent(JSON.stringify(data))}`;
    try {
      await navigator.clipboard.writeText(url.toString());
      showToast("Shareable build link copied.");
    } catch (error) {
      window.location.hash = url.hash;
      showToast("Build link added to the address bar — copy it to share.", 4000);
    }
  });

  resetViewButton?.addEventListener("click", () => {
    focusStageView(activeStage, true);
  });

  nextButton?.addEventListener("click", () => {
    const index = stageOrder.indexOf(activeStage);
    if (index < stageOrder.length - 1) {
      selectStage(stageOrder[index + 1]);
    } else {
      showToast("Build reviewed — ready for checkout.");
    }
  });

  builderForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const issue = getCheckoutIssue();
    if (issue) {
      showToast(issue, 4800);
      syncCheckoutState();
      return;
    }

    const service = getServicePricing();
    const upgradeLines = resolveUpgradeLines(currentUpgradeTotal) || [];
    const buildCode = createBuildCode();
    const originalLabel = cartButton?.textContent || "Add build to cart";
    if (cartButton) {
      cartButton.disabled = true;
      cartButton.textContent = "Adding build…";
    }
    builder.classList.add("is-adding-to-cart");

    try {
      const formData = new FormData(builderForm);
      formData.set("id", String(service.variantId));
      formData.set("quantity", "1");
      formData.set("properties[Rush build code]", buildCode);
      formData.set("properties[Configured total]", money(currentTotal));
      formData.set("properties[Paid upgrades]", money(currentUpgradeTotal));

      const controllerResponse = await fetch(cartAddUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      });
      if (!controllerResponse.ok) {
        const error = await controllerResponse.json().catch(() => ({}));
        throw new Error(error.description || "The controller could not be added to cart.");
      }
      const controllerItem = await controllerResponse.json();

      if (upgradeLines.length) {
        const feeResponse = await fetch(cartAddUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: upgradeLines.map((line) => ({
              ...line,
              properties: {
                "_Rush build code": buildCode,
                "_Rush charge": "Custom Lab upgrades"
              }
            }))
          })
        });
        if (!feeResponse.ok) {
          const error = await feeResponse.json().catch(() => ({}));
          await fetch(cartChangeUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              id: controllerItem.key,
              quantity: Math.max(0, Number(controllerItem.quantity || 1) - 1)
            })
          }).catch(() => {});
          throw new Error(error.description || "Upgrade pricing could not be added. Please contact support before checkout.");
        }
      }

      if (buildCodeLabel) buildCodeLabel.textContent = buildCode;
      window.location.assign(cartUrl);
    } catch (error) {
      showToast(error.message || "The build could not be added. Please try again.", 5200);
      if (checkoutStatus) {
        checkoutStatus.textContent = error.message || "The build could not be added. Please try again.";
        checkoutStatus.classList.add("has-error");
      }
      if (cartButton) {
        cartButton.disabled = false;
        cartButton.textContent = originalLabel;
      }
      builder.classList.remove("is-adding-to-cart");
    }
  });

  builder.querySelector("[data-builder-demo-cart]")?.addEventListener("click", () => {
    showToast("Build saved. Connect a controller product in the theme editor to enable checkout.", 3600);
  });

  builder.querySelectorAll("[data-option-group].is-selected").forEach((button) => {
    selections.set(button.dataset.optionGroup, { name: button.dataset.option, price: Number(button.dataset.price || 0) });
  });
  const sharedBuild = window.location.hash.startsWith("#rush-build=")
    ? window.location.hash.slice("#rush-build=".length)
    : "";
  if (sharedBuild) {
    try { applyBuild(JSON.parse(decodeURIComponent(sharedBuild)), false); } catch (error) { /* Ignore malformed shared builds. */ }
  } else {
    try {
      const savedBuild = localStorage.getItem("rush-controller-build");
      if (savedBuild) applyBuild(JSON.parse(savedBuild), false);
    } catch (error) { /* Local storage may be unavailable. */ }
  }
  connectControllerViewer();
  selectStage(activeStage);
  syncSummary();
})();
